import { UntypedFormGroup } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { DayBlockDTO, IAnswerOption, IDayBlockDTO } from './day-block';
import { BLOCK_TYPES } from '../utils/constants';
import { ImageBlockDTO } from './image-block';
import { WYSIWYGBlock } from './wysiwyg-block';
import { KaraokeDTO } from './grade-unit/karaoke';
import { StudentAnswerDTO } from './answer';
import { GetAttemptDTO } from './attempt';

export enum QuizTypes {
  MULTIPLECHOICE = 'Multiple Choice',
  SINGLECHOICE = 'Single Choice',
  FREEANSWER = 'Free Answer',
  BOOLEANCHOICE = 'Boolean Choice',
}

export interface IQuizBlockDTO extends IDayBlockDTO {
  quizType: QuizTypes;
  file?: FileList;
  options?: IAnswerOption[];
  trueOrFalse?: boolean;
  text?: string;
  quizOptions: QuizOptionDTO[];
  answers: StudentAnswerDTO[];
  answerAttempts: GetAttemptDTO[];
  gradeUnitId?: number;
  gradeUnitDayId?: number;
  layout: 'row' | 'grid';
}

export class OptionContentDTO {
  id?: number = null;
  block: WYSIWYGBlock | KaraokeDTO | ImageBlockDTO = null;
}

export class ImageContentDTO extends OptionContentDTO {
  constructor() {
    super();
    this.block = new ImageBlockDTO();
  }
}

export class QuizOptionDTO {
  id: number = null;
  blockId: number = null;
  position: number = 0;
  isCorrect: boolean = false;
  imageContentId: number = null;
  imageContent: ImageContentDTO = null;
  textContentId: number = null;
  textContent: OptionContentDTO = null;
}
export class QuizBlockDTO extends DayBlockDTO implements IQuizBlockDTO {
  id: number = 0;
  position: number = 0;
  dayNumber: number = 0;
  quizType: QuizTypes;
  file?: FileList;
  trueOrFalse?: boolean;
  options?: IAnswerOption[];
  text?: string;
  quizOptions: QuizOptionDTO[] = [];
  answers: StudentAnswerDTO[] = [];
  answerAttempts: GetAttemptDTO[] = [];
  layout: 'row' | 'grid' = 'row';

  constructor(configOverride?: Partial<IQuizBlockDTO>) {
    super();
    this.blockType = BLOCK_TYPES.QuizBlock;
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IQuizStepper {
  stepper: MatStepper;
  form: UntypedFormGroup;
  loaders: boolean[];
  index: number;
  quiz: IQuizBlockDTO;
}

export class QuizStepper implements IQuizStepper {
  stepper: MatStepper = null;
  form: UntypedFormGroup = null;
  loaders: boolean[] = [];
  index: number = 0;
  quiz: IQuizBlockDTO = new QuizBlockDTO();

  constructor(configOverride?: Partial<IQuizStepper>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export class UpdateQuizBlockDto {
  layout: 'grid' | 'row';

  quizType?: string;

  trueOrFalse?: boolean;

  text?: string;
}
